import type { BannerItem } from "@/types/work";

export const siteInfo = {
  name: "妻子的姐姐",
  slogan: "剧情介绍 · 演员资讯 · 影视更新",
  intro:
    "「妻子的姐姐」是一个面向广大影视爱好者的影视资料平台，汇集电影与电视剧的剧情介绍、演员信息、更新资讯与播放展示，帮助影迷更高效地了解每一部作品。",
  email: "contact@qizi-jiejie.demo",
  weibo: "@妻子的姐姐影视站",
  address: "线上运营 · 无实体门店",
  icp: "演示站点 · 仅供内容浏览使用",
};

export const genres = [
  "剧情",
  "悬疑",
  "犯罪",
  "爱情",
  "动作",
  "科幻",
  "奇幻",
  "冒险",
  "古装",
  "历史",
  "家庭",
  "青春",
  "武侠",
  "惊悚",
  "灾难",
];

export const regions = [
  "中国大陆",
  "中国香港",
  "美国",
  "韩国",
  "日本",
  "英国",
];

export const years = [2024, 2023, 2022, 2021, 2020];

export const banners: BannerItem[] = [
  {
    workId: "w1",
    kicker: "本周焦点 · 悬疑剧情",
    title: "夜航之港",
    tagline:
      "一座被浓雾笼罩的海港小城，旧案重提之际，所有线索都指向了那个沉默多年的摆渡人。",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20stylized%20night%20harbor%20scene%20with%20dense%20fog%2C%20a%20lone%20ferry%20pier%20under%20amber%20lamp%20light%2C%20moody%20deep%20navy%20and%20warm%20orange%20tones%2C%20film%20grain%20texture%2C%20atmospheric%20artistic%20composition%2C%20no%20text%2C%20high%20detail%20editorial%20cinematography&width=1600&height=900&seq=w1-backdrop&orientation=landscape",
  },
  {
    workId: "w3",
    kicker: "奇幻冒险 · 口碑佳作",
    title: "山海谣",
    tagline:
      "少年循着一卷残破的古谣走入群山，那里沉睡着被世人遗忘的山与海，也沉睡着他自己的名字。",
    backdrop:
      "https://readdy.ai/api/search-image?query=epic%20stylized%20ancient%20mountain%20range%20under%20a%20dramatic%20sunset%20sky%2C%20misty%20layered%20peaks%2C%20golden%20amber%20light%20with%20deep%20navy%20shadows%2C%20mythical%20oriental%20atmosphere%2C%20film%20grain%2C%20artistic%20painterly%20composition%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=w3-backdrop&orientation=landscape",
  },
  {
    workId: "w13",
    kicker: "科幻悬疑 · 全网热议",
    title: "潮汐之下",
    tagline:
      "当海水在深夜逆流，一座沿海实验站的七名成员发现，他们记录的时间正在悄悄缩短。",
    backdrop:
      "https://readdy.ai/api/search-image?query=futuristic%20stylized%20coastal%20research%20station%20at%20dusk%20with%20glowing%20horizon%2C%20surreal%20ocean%20waves%20flowing%20backwards%2C%20teal%20and%20deep%20navy%20palette%20with%20orange%20highlights%2C%20cinematic%20science%20fiction%20mood%2C%20film%20grain%2C%20artistic%20composition%2C%20no%20text&width=1600&height=900&seq=w13-backdrop&orientation=landscape",
  },
  {
    workId: "w10",
    kicker: "古装权谋 · 更新中",
    title: "落雪听禅",
    tagline:
      "一场大雪掩埋了旧朝的恩怨，也掩埋了一封足以颠覆朝堂的密信，而翻开它的人还未出生。",
    backdrop:
      "https://readdy.ai/api/search-image?query=stylized%20ancient%20chinese%20palace%20courtyard%20covered%20in%20falling%20snow%20at%20blue%20hour%2C%20red%20lanterns%20glowing%20warmly%2C%20deep%20navy%20and%20amber%20tones%2C%20elegant%20oriental%20painterly%20style%2C%20film%20grain%2C%20cinematic%20composition%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=w10-backdrop&orientation=landscape",
  },
  {
    workId: "w6",
    kicker: "动作犯罪 · 港片回归",
    title: "逆光而行",
    tagline:
      "退隐多年的拆弹专家被迫重返一线，他要在四十八小时里拆掉的，不只是一枚炸弹。",
    backdrop:
      "https://readdy.ai/api/search-image?query=stylized%20neon-lit%20hong%20kong%20street%20at%20night%20seen%20from%20above%2C%20rain%20reflections%20on%20asphalt%2C%20deep%20navy%20shadows%20with%20warm%20orange%20neon%20glow%2C%20action%20thriller%20cinematic%20mood%2C%20film%20grain%2C%20dramatic%20artistic%20composition%2C%20no%20text&width=1600&height=900&seq=w6-backdrop&orientation=landscape",
  },
];